import { useTranslation } from 'react-i18next'

import { LittleText, Text } from '@/components/common/UI'
import { Icons } from '@/components/icons'
import { Card, CardHeader, CardBody, Divider, Link } from '@/components/nextui'

export const Financial = (): JSX.Element => {
    const { t } = useTranslation()
    const items = [
        {
            id: 1,
            icon: <Icons.GraduationCap />,
            title: t('footer.carrusel.financialOptions.option1'),
            href: 'https://universidadean.edu.co/sites/default/files/2026-02/Resolucion%20No%20010%20de%202026.pdf'
        },
        {
            id: 2,
            icon: <Icons.University />,
            title: t('footer.carrusel.financialOptions.option2'),
            href: 'https://universidadean.edu.co/admisiones/convenios-corporativos'
        },
        {
            id: 3,
            icon: <Icons.People />,
            title: t('footer.carrusel.financialOptions.option3'),
            href: 'https://universidadean.edu.co/admisiones/descuentos-e-incentivos/perteneces-un-grupo-etnico'
        },
        {
            id: 4,
            icon: <Icons.Home />,
            title: t('footer.carrusel.financialOptions.option4'),
            href: 'https://universidadean.edu.co/graduados/descuentos-graduado-familiar-de-graduado-y-egresado-no-graduado'
        }
    ]

    return (
        <Card className="w-full h-full">
            <CardHeader className="flex justify-center">
                <Text
                    text={t('footer.carrusel.financialOptions.title')}
                    className="font-semibold text-center"
                />
            </CardHeader>
            <CardBody className="flex flex-col justify-between h-full gap-3">
                <div className="grid gap-4">
                    {items.map((e) => (
                        <span
                            key={e.id}
                            className="flex items-center gap-3"
                        >
                            {e.icon}{' '}
                            <Link
                                isExternal
                                href={e.href}
                            >
                                <LittleText
                                    text={e.title}
                                    className="text-center text-base"
                                />
                            </Link>
                        </span>
                    ))}
                </div>
                <Divider />
                <div className="flex items-center gap-2">
                    <LittleText
                        text={t('footer.carrusel.financialOptions.contactInfo')}
                        className="text-center"
                    />
                    <Link
                        isExternal
                        href="https://universidadean.edu.co/admisiones/financiacion"
                    >
                        <LittleText
                            text="Planes de financiación | Universidad Ean"
                            className="text-center"
                        />
                    </Link>
                </div>
            </CardBody>
        </Card>
    )
}
